// import React, { useEffect, useState } from "react";
// import SuperAdminSideBar from "../common/SuperAdminSideBar";
// import LogoutModal from "../ui/LogoutModal";
// import { useAuthStore } from "../../context/useAuthStore";

// interface SuperAdminDashboardLayoutProps {
//   children: React.ReactNode;
// }

// const SuperAdminDashboardLayout: React.FC<SuperAdminDashboardLayoutProps> = ({ children }) => {
//   const { user, logout } = useAuthStore();
//   const [showModal, setShowModal] = useState(false);
//   const [userName, setUserName] = useState<string>("");

//   useEffect(() => {
//     if (user) {
//       setUserName(user.fullName || "Unknown User");
//     } else {
//       setUserName("User");
//     }
//   }, [user]);

//   const handleModalClose = () => {
//     setShowModal(false);
//   };

//   const handleLogoutClick = async () => {
//     await logout();
//     setShowModal(false);
//   };

//   return (
//     <main className="dashboardLayoutContainer no-scrollbar">
//       <SuperAdminSideBar onLogout={() => setShowModal(true)} />
//       <section className="dashboardLayoutSection p-4 no-scrollbar">
//         {children}
//       </section>
//       <LogoutModal
//         userName={userName}
//         showModal={showModal}
//         onClose={handleModalClose}
//         onLogout={handleLogoutClick}
//       />
//     </main>
//   );
// };

// export default SuperAdminDashboardLayout;

import React, { useEffect, useState } from "react";
import SuperAdminSideBar from "../common/SuperAdminSideBar";
import LogoutModal from "../ui/LogoutModal";
import { useAuthStore } from "../../context/useAuthStore";
import { Outlet } from "react-router-dom";

interface SuperAdminDashboardLayoutProps {
  children?: React.ReactNode;
}

const SuperAdminDashboardLayout: React.FC<SuperAdminDashboardLayoutProps> = () => {
  const { user, logout } = useAuthStore();
  const [showModal, setShowModal] = useState(false);
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    if (user) {
      setUserName(user.fullName || "Unknown User");
    } else {
      setUserName("User");
    }
  }, [user]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleLogoutClick = async () => {
    await logout();
    setShowModal(false);
  };

  return (
    <main className="dashboardLayoutContainer no-scrollbar">
      <SuperAdminSideBar onLogout={() => setShowModal(true)} />
      <section className="dashboardLayoutSection p-4 no-scrollbar">
        <Outlet />
      </section>
      <LogoutModal
        userName={userName}
        showModal={showModal}
        onClose={handleModalClose}
        onLogout={handleLogoutClick}
      />
    </main>
  );
};

export default SuperAdminDashboardLayout;
